// extracted by mini-css-extract-plugin
export default {"container":"res_2US6Q","items":"res_ite_3C2RW","item":"res_ite_3lsXy","scrollSnap":"res_scr_2fJzn"};